<template>
	<main-menu-bar>
		<user-menu class="ml-auto"/>
	</main-menu-bar>
</template>

<script>
import MainMenuBar from '../shared/main-menu/MainMenuBar';
import UserMenu from '../shared/main-menu/UserMenu';

export default {
	components: { MainMenuBar, UserMenu },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/guide-manual-acceptance/TopBar.vue